import { jsx as C } from "react/jsx-runtime";
const r = ({
  width: L,
  height: o,
  className: t
}) => /* @__PURE__ */ C(
  "svg",
  {
    className: t,
    fill: "none",
    height: o,
    viewBox: "0 0 22 20",
    width: L,
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ C(
      "path",
      {
        d: "M14.8694 2.43624L14.8693 2.43594C14.4871 1.54391 13.5866 0.949756 12.6042 0.949756H9.3958C8.41317 0.949756 7.5126 1.54419 7.1305 2.46291L5.53926 6.24387H3.43354C1.85154 6.24387 0.67751 7.6756 1.00507 9.21604L2.66272 17.1042L2.66278 17.1045C2.90845 18.2395 3.91827 19.0498 5.09121 19.0498H16.9088C18.0817 19.0498 19.0916 18.2395 19.3372 17.1045L19.3373 17.1042L20.995 9.21592L20.995 9.21587C21.3223 7.64949 20.1489 6.2174 18.5665 6.2174H16.4607L14.8694 2.43624ZM8.21192 2.89877L8.21193 2.89874C8.41806 2.41405 8.88133 2.10858 9.3958 2.10858H12.6042C13.1187 2.10858 13.5819 2.41405 13.7881 2.89874L13.7881 2.89877L15.2022 6.2174H6.7978L8.21192 2.89877ZM19.5426 7.85936L19.5424 7.85951L19.5458 7.86314C19.8286 8.16857 19.9314 8.57554 19.8543 8.95725C19.8543 8.95734 19.8543 8.95742 19.8543 8.9575L18.1967 16.8454C18.0679 17.4574 17.527 17.8909 16.9088 17.8909H5.09121C4.47304 17.8909 3.9321 17.4574 3.80331 16.8454C3.80331 16.8454 3.80331 16.8453 3.80331 16.8453L2.14572 8.9575C2.14571 8.95744 2.14569 8.95738 2.14568 8.95732C2.06862 8.57556 2.17129 8.16707 2.40315 7.86038C2.66176 7.55368 3.02211 7.37623 3.4068 7.37623H18.5397C18.9264 7.37623 19.3121 7.55515 19.5426 7.85936Z",
        fill: "currentColor"
      }
    )
  }
);
export {
  r as Content
};
